<div class="container-fluid">
  <div class="row">
    <div class="wide-card mt-4">
      @if (topic) {
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              @if (thumbnail) {
                <img
                  class="card-img-left"
                  [src]="thumbnail | imageUrl:thumbnailTransformations"
                  [alt]="thumbnail.alt_text"
                  />
              }
            </div>
            <div class="col-md-9">
              <div class="card-body" *transloco="let t">
                <h5 class="card-title">{{ topic.name }}</h5>
                <p class="card-text" [innerHTML]="topic.description"></p>
                <div class="info-group flex-wrap gap-2">
                  <div class="text-badge">
                    <p class="title">
                      {{ t('navigation.courses') }}
                    </p>
                    <p class="value">
                      {{ courses?.length }}
                    </p>
                  </div>
                  @if (tipCount){
                    @if (tipCount) {
                      <span class="splitter"></span>
                    }
                    @if (tipCount) {
                      <div class="text-badge">
                        <p class="title">
                          {{ t('content.tips') }}
                        </p>
                        <p class="value">
                          {{ tipCount }}
                        </p>
                      </div>
                    }
                    } @if (accreditations?.length){
                    <span class="splitter"></span>
                    <button type="button" class="img-badge btn btn-primary" (click)="gotoRelation('accreditations')">
                      <i class="fa-solid fa-file-certificate fa-xl"></i>
                      <p class="title">
                        {{ t('marketing.accreditation_available') }}
                      </p>
                      <i class="fa-solid fa-arrow-right"></i>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row" *transloco="let t">
    <div class="col-md-6 mt-4">
      <button
        class="btn button-wide btn-warning h-100"
        [routerLink]="['tips']"
        routerLinkActive="router-link-active"
        >
        <p>{{ t('content.get_tips') }}</p>
        <i class="fa-solid fa-angle-right"></i>
      </button>
    </div>
    <div class="col-md-6 mt-4">
      <button
        class="btn button-wide btn-primary h-100"
        (click)="gotoRelation('courses')"
        >
        <p>{{ t('content.explore_courses') }}</p>
        <i class="fa-solid fa-angle-right"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 mt-4">
      @if (loadingObject.tips) {
        <multisite-loader-globe-animation-detail [width]="100" [height]="100">
        </multisite-loader-globe-animation-detail>
      }
      @if (!loadingObject.tips && latestTipsAsGenericContent?.length) {
        <multisite-carousel-card
          [content]="latestTipsAsGenericContent"
          [loading]="loadingObject.tips"
          [ratingMax]="5"
          [imageTransformations]="'w_275/'"
          [title_translationKey]="'content.latest_tips'"
          [cta_translationKey]="'content.go_to_tip'"
          (actionTriggered)="gotoTip($event)"
          >
        </multisite-carousel-card>
      }
    </div>
    <div class="col-md-6 mt-4">
      @if (loadingObject.reviews) {
        <multisite-loader-globe-animation-detail [width]="100" [height]="100">
        </multisite-loader-globe-animation-detail>
      }
      @if (!loadingObject.reviews && topPublicReviewsAsGenericContent?.length) {
        <multisite-carousel-card-quotations
          [content]="topPublicReviewsAsGenericContent"
          [loading]="loadingObject.reviews"
          [ratingMax]="5"
          [title_translationKey]="'content.people_saying'"
          >
        </multisite-carousel-card-quotations>
      }
    </div>
  </div>
</div>
